import { Card, CardContent, Box } from '@mui/material';
import { marked } from 'marked';
import introductionMd from '../../assets/documentation/introduction.md?raw';
import { useMeProfile } from '../hooks/useApi';

export function IntroductionCard() {
  const { data } = useMeProfile();
  const baseUrl = data?.publicDocsBaseUrl ?? '';
  const htmlContent = marked.parse(introductionMd.split('{{PUBLIC_DOCS_URL}}').join(baseUrl));

  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            '& h1': {
              fontSize: '1.5rem',
              fontWeight: 500,
              marginTop: 0,
              marginBottom: '1rem',
            },
            '& h2': {
              fontSize: '1.25rem',
              fontWeight: 500,
              marginTop: '1.5rem',
              marginBottom: '0.75rem',
            },
            '& ul': {
              marginTop: '0.5rem',
              marginBottom: '1rem',
              paddingLeft: '1.5rem',
            },
            '& li': {
              marginBottom: '0.25rem',
            },
            '& ol': {
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: '1rem',
              listStylePosition: 'inside',
              padding: 0,
              marginTop: '0.5rem',
              marginBottom: '1rem',
            },
            '& ol li': {
              marginBottom: 0,
            },
            '& p': {
              marginTop: '0.5rem',
              marginBottom: '0.5rem',
            },
            '& a': {
              color: 'primary.main',
              textDecoration: 'underline',
            },
          }}
          dangerouslySetInnerHTML={{ __html: htmlContent as string }}
        />
      </CardContent>
    </Card>
  );
}
